// extracted by mini-css-extract-plugin
export var checkbox = "_4e-0";
export var circle = "_4e-3";
export var horizontalContainer = "_4e-7";
export var sm = "_4e-5";
export var switch0 = "_4e-2";
export var switchDisabled = "_4e-8";
export var switchEnabled = "_4e-1";
export var textSwitchContainer = "_4e-9";
export var textSwitchOption = "_4e-a";
export var textSwitchOptionSelected = "_4e-b";
export var verticalContainer = "_4e-6";
export var xs = "_4e-4";